/**
 * @desc 平台站点店铺查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlatformSiteShopResponseDto>>;
export function request(
  body: defs.basics.PlatformSiteShopRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/platformSiteShop/getPlatformSiteShopList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
